// extracted by mini-css-extract-plugin
export default {"container":"HF-z","header":"IF-z","details":"JF-z","link":"KF-z"};